import generateOrganicSuggestion from './generateOrganicItem';
import generatePeopleSuggestion from './generatePeopleItem';
import generateProgramSuggestion from './generateProgramItem';

const autoCompleteTemplateFn = () => {
    const data = [
        {
            id: 'fb-he-organic',
            heading: 'Suggestions',
            source: {
                url: 'https://squiz-search.clients.funnelback.com/s/suggest.json',
                params: {
                    fmt: 'json++',
                    alpha: 0.5,
                    show: 5,
                    sort: 0,
                    profile: '_default',
                    collection: 'pnp~sp-higher-education-meta',
                },
            },
            generateItemFunc: generateOrganicSuggestion,
        },
        {
            id: 'fb-he-people',
            heading: 'Peoples',
            source: {
                url: 'https://squiz-search.clients.funnelback.com/s/suggest.json',
                params: {
                    fmt: 'json++',
                    alpha: 0.5,
                    show: 5,
                    sort: 0,
                    profile: 'auto-completion-people',
                    collection: 'pnp~sp-higher-education-meta',
                },
            },
            generateItemFunc: generatePeopleSuggestion,
        },
        {
            id: 'fb-he-programs',
            heading: 'Programs',
            source: {
                url: 'https://squiz-search.clients.funnelback.com/s/suggest.json',
                params: {
                    fmt: 'json++',
                    alpha: 0.5,
                    show: 5,
                    sort: 0,
                    profile: 'auto-completion-programs',
                    collection: 'pnp~sp-higher-education-meta',
                },
            },
            generateItemFunc: generateProgramSuggestion,
        },
    ];
    return data;
};

export default autoCompleteTemplateFn;
